'use client';

import { CalvinUser } from '@api';
import { action, makeObservable, observable } from 'mobx';

export class UserStore {
  user: CalvinUser = {
    username: '',
    email: '',
    id: 0,
    calvinProfile: undefined,
  };

  constructor() {
    makeObservable(this, {
      user: observable,
      setUser: action.bound,
    });
  }

  setUser(data) {
    this.user = { ...this.user, ...data };
  }
}

export const userStore = new UserStore();
